import React from 'react';
import { Table, Select, Modal, message, Input, Space } from 'antd';
import dayjs from 'dayjs';

export const VersionList = () => {
    const [list, setList]  = React.useState([]);
    const [current, setCurrent] = React.useState();

    const getTemplateList = async () => {
        const response = await fetch('/api/sys/template-list');
        const result = await response.json();

        if(result?.success) {
            return result?.data?.template_list || [];
        }
        return [];
    };

    React.useEffect(() => {
        getTemplateList().then(res => {
            setList(res.map(item =>{
                const i = { ...item, label: item.user_version, value: item.template_id };
                return i;
            }));

            setCurrent(res[0]?.template_id);
        });
    }, []);

    const onChange = (value, option) => {
        console.log(value, option);
        setCurrent(value);
    };

    VersionList.getSelected  = () => { 
        return list.find(item => item.template_id === current);
    };

    return (
        <Select options={list} onChange={(v, option) => onChange(v, option)} value={current} style={{width: '100%'}} />
    );
};



export default () => {
    const [ dataSource, setDataSource ] = React.useState([]);

    const getMiniList = async () => {
        const res = await fetch(`/api/sys/mini-oauth-list`);
        const result = await res.json();

        if (result?.success) {
            return result?.data || [];
        }

        return [];
    };

    

    React.useEffect(() => {
        getMiniList().then(data => {
            if(data) setDataSource(data);
        });
    }, []);

    const columns = [
        {
            title: 'accId',
            dataIndex: 'acc',
            render: (acc) => acc.accId,
        },
        {
            title: '公司名',
            dataIndex: 'acc',
            render: (acc) => acc.companyName,
        },
        {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            render: (text, record) => {
                return (
                    <Space>
                        <a onClick={() => republic(record)}>预发</a>
                        <a onClick={() => getQRcode(record.accId)}>体验版</a>
                        <a onClick={() => getTrialQRcode(record.accId)}>参数体验版</a>
                    </Space>
                );
            },
        },
    ];

    const getTrialQRcode = async (accId) => { 

        Modal.confirm({
            title: '输入参数',
            content: <Input placeholder="请输入参数" id="params" />,
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
                const scene = document.getElementById('params').value;
                console.log(scene);
                getQRcode(accId, scene)
            }
        })
    };

    const republic = async (record) => {

        Modal.confirm({
            title: '确定要预发吗？',
            content: <div>
                <div>appid: {record.appid}</div>
                <div>accId: {record.accId}</div>
                <div>公司名: {record.acc.companyName}</div>
                <VersionList id='template-list' />
            </div>,
            onOk: async () => {
                let accId = record.acc.accId;
                const version = VersionList.getSelected();
                // console.log(accId, version);
                const {template_id, user_version} = version;
                await republicRequest({templateId: template_id, accId, userVersion: user_version});
                return false
            }
        })
    };

    const republicRequest = async (params) => {
        const response = await fetch(`/api/sys/mini-republish`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        });
        const result = await response.json();

        if (result.success) {
            message.success('发布成功！');
        }else  {
            message.error(result.data);
        }
    };

    const getQRcode = async (accId = '', scene = '') => {
        scene = scene.trim();
        scene = encodeURIComponent(scene);
        Modal.info({icon: null, content: <div style={{textAlign: 'center'}}><p>微信扫码进入体验版</p><img width={160} src={`/api/sys/mini-trial-code?accId=${accId}&scene=${scene}`} /></div>});
    };

    return (
        <Table rowKey="appid" columns={columns} dataSource={dataSource} />
    )
}